$(document).ready(function () {

  // ------------------- TB-Category-featured Start -------------------
    var tb_category_featured = $("#TB-Category-featured .owl-carousel").owlCarousel({
                items: 4,
                loop: true,
                nav: true,
                dots: false,
                margin: 25,
                responsive: {
                    0: {
                        items: 1,
                    },
                    481: {
                        items: 2
                    },
                    992: {
                        items: 3
                    },
                    1300: {
                        items: 4
                    }
                }
            });
    // ------------------- TB-Category-featured End -------------------

  // ------------------- TB-testimonial-cms Start -------------------
    var tb_testimonial_cms =  $("#TB-testimonial-cms .owl-carousel").owlCarousel({
                items: 2,
                loop: false,
                nav: true,
                dots: false,
                margin: 40,
                responsive: {
                    0: {
                        items: 1,
                        margin: 20,
                    },
                    992: {
                        items: 2
                    }
                }
            });
    // ------------------- TB-testimonial-cms End -------------------
    
  // ------------------- TB_Services_CMS Start -------------------
    var tb_services_cms = $('#TB-Service-cms .owl-carousel').owlCarousel({
       items: 4,
        nav: true,
        dots: false,
        loop: false,
        center: false,
        margin: 15,
        autoplayHoverPause: true,
        autoplay: true,
        responsive: {
          0: {
            items: 1
          },
          576: {
            items: 2
          },
          768: {
            items: 2
          },
          992: {
            items: 3
          },
          1300: {
            items: 4
          }
        }
    });
    // ------------------- TB_Services_CMS End -------------------

    var tb_video_cms = $(".tb-video-row.owl-carousel").owlCarousel({
      items: 4,
      nav: true,
      dots: false,
      loop: true,
      center: true,
      margin: 20,
      autoplayHoverPause: true,
      autoplay: false,
      responsive: {
        0: {
          items: 1,
          center: false,
          stagePadding: 0
        },
        576: {
          items: 2
        },
        768: {
          items: 2
        },
        992: {
          items: 3
        },
        1300: {
          items: 4
        },
        1500: {
          items: 3,
          stagePadding: 150
        },
        1700: {
          items: 5
        }
      }
    });
  
});
  